(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.isHomeTransparent = this.querySelector('.header-wrapper--home-transparent');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prospirity-feature-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProspirityFeatureCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.prospirity-feature-carousel__track');
      this.slides = Array.from(this.querySelectorAll('.prospirity-feature-carousel__slide'));
      this.dots = Array.from(this.querySelectorAll('.prospirity-feature-carousel__dot'));
      this.prevBtn = this.querySelector('.prospirity-feature-carousel__arrow--prev');
      this.nextBtn = this.querySelector('.prospirity-feature-carousel__arrow--next');
      this.index = 0;
      this.paused = false;
      if (this.slides.length < 2) return;

      this.dots.forEach((d) => d.addEventListener('click', () => {
        this.go(parseInt(d.dataset.goto, 10));
        this.restart();
      }));
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.autoplay === 'true' && !reduce) this.start();
    }
    go(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.track.style.transform = `translateX(-${this.index * (100 / this.slides.length)}%)`;
      this.slides.forEach((s, n) => {
        const on = n === this.index;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === this.index));
    }
    start() {
      const ms = parseInt(this.dataset.interval, 10) || 6000;
      this.timer = setInterval(() => { if (!this.paused) this.go(this.index + 1); }, ms);
    }
    restart() { clearInterval(this.timer); this.start(); }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  if (!customElements.get('prospirity-feature-carousel')) customElements.define('prospirity-feature-carousel', ProspirityFeatureCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prospirity-featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProspirityFeaturedProduct extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.prospirity-featured-product__item'));
      this.dots = Array.from(this.querySelectorAll('[data-go]'));
      this.previousButtons = Array.from(this.querySelectorAll('[data-prev]'));
      this.nextButtons = Array.from(this.querySelectorAll('[data-next]'));
      this.index = 0;
      if (this.items.length < 2) return;
      this.previousButtons.forEach((button) => button.addEventListener('click', () => this.go(this.index - 1)));
      this.nextButtons.forEach((button) => button.addEventListener('click', () => this.go(this.index + 1)));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.go))));
      this.track = this.querySelector('.prospirity-featured-product__track');
      if (this.track) {
        this.track.classList.add('is-swipeable');
        this.track.addEventListener('pointerdown', (event) => this.startSwipe(event));
        // Imagem e link são arrastáveis nativamente; isso cancelaria o gesto com mouse.
        this.track.addEventListener('dragstart', (event) => event.preventDefault());
        // Soltar o arraste sobre a imagem não deve abrir o produto.
        this.track.addEventListener('click', (event) => {
          if (!this.suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        }, true);
      }
      if (this.dataset.autoplay === 'true') {
        this.timer = window.setInterval(() => this.go(this.index + 1), Number(this.dataset.interval) || 5000);
        this.addEventListener('mouseenter', () => window.clearInterval(this.timer), { once: true });
      }
    }
    startSwipe(event) {
      if (!event.isPrimary || event.button !== 0 || event.target.closest('button, input, select, textarea, label')) return;
      const startX = event.clientX;
      const startY = event.clientY;
      const active = this.items[this.index];
      let dragging = false;
      // O produto acompanha o dedo/mouse enquanto o gesto é horizontal.
      const move = (moveEvent) => {
        const deltaX = moveEvent.clientX - startX;
        if (!dragging) {
          if (Math.abs(deltaX) < 8 || Math.abs(deltaX) < Math.abs(moveEvent.clientY - startY)) return;
          dragging = true;
          active.classList.add('is-dragging');
        }
        active.style.setProperty('--pfp-shift', `${deltaX}px`);
        active.style.opacity = String(Math.max(0.35, 1 - Math.abs(deltaX) / 500));
      };
      // Escuta na window: o gesto pode terminar fora da vitrine.
      const end = (endEvent) => {
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', end);
        window.removeEventListener('pointercancel', end);
        const deltaX = endEvent.clientX - startX;
        const deltaY = endEvent.clientY - startY;
        if (endEvent.type === 'pointercancel' || Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) {
          this.release(active, '0px');
          return;
        }
        this.suppressClick = true;
        window.setTimeout(() => { this.suppressClick = false; }, 0);
        window.clearInterval(this.timer);
        const step = deltaX < 0 ? 1 : -1;
        this.go(this.index + step, step);
      };
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
    }
    // Devolve o item às transições do CSS, animando até o deslocamento indicado.
    release(item, shift) {
      item.classList.remove('is-dragging');
      item.style.opacity = '';
      item.style.setProperty('--pfp-shift', shift);
    }
    go(nextIndex, direction) {
      const target = (nextIndex + this.items.length) % this.items.length;
      if (target === this.index) return;
      const step = direction || (nextIndex > this.index ? 1 : -1);
      const distance = 64;
      const entering = this.items[target];
      // Posiciona quem entra do lado oposto sem animar, e só então anima até o centro.
      entering.classList.add('is-dragging');
      entering.style.setProperty('--pfp-shift', `${step * distance}px`);
      void entering.offsetWidth;
      this.release(entering, '0px');
      // Após um arraste, quem sai segue a partir de onde foi solto, sem voltar ao centro.
      const leaving = this.items[this.index];
      const dragged = Math.abs(parseFloat(leaving.style.getPropertyValue('--pfp-shift')) || 0);
      this.release(leaving, `${-step * (dragged + distance)}px`);
      this.index = target;
      this.items.forEach((item, index) => {
        const active = index === this.index;
        item.classList.toggle('is-active', active);
        item.toggleAttribute('aria-hidden', !active);
      });
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === this.index));
    }
    disconnectedCallback() { window.clearInterval(this.timer); }
  }
  if (!customElements.get('prospirity-featured-product')) customElements.define('prospirity-featured-product', ProspirityFeaturedProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prospirity-hero"] && !Shopify.designMode) return;
  try {
    
  class ProspirityHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.prospirity-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.prospirity-hero__dot'));
      this.index = 0;
      this.paused = false;
      this.inViewport = false;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.syncVideos();
      if (this.slides.length < 2) return;

      this.dots.forEach((d) => d.addEventListener('click', () => {
        this.go(parseInt(d.dataset.goto, 10));
        this.restart();
      }));
      this.addEventListener('mouseenter', () => { this.paused = true; });
      this.addEventListener('mouseleave', () => { this.paused = false; });
      this.querySelectorAll('.prospirity-hero__arrow').forEach((btn) => btn.addEventListener('click', () => {
        this.go(this.index + parseInt(btn.dataset.dir, 10));
        this.restart();
      }));
      this.bindDrag();

      this.canAutoplay = this.dataset.autoplay === 'true' && !this.reduceMotion;
      this.observer = new IntersectionObserver((entries) => {
        this.inViewport = entries[0]?.isIntersecting;
        if (this.inViewport && this.canAutoplay) this.start(); else this.stop();
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    // Arrastar (mouse) ou deslizar (toque) troca de slide. Se houve arraste, o clique que o
    // navegador dispara em seguida no link do banner é cancelado para não navegar sem querer.
    bindDrag() {
      const track = this.querySelector('.prospirity-hero__track');
      let startX = null;
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        startX = e.clientX;
        this.dragged = false;
        this.paused = true;
        this.userPauseUntil = Date.now() + 8000;
      });
      track.addEventListener('pointermove', (e) => {
        if (startX === null) return;
        if (Math.abs(e.clientX - startX) > 10) { this.dragged = true; this.classList.add('is-dragging'); }
      });
      const end = (e) => {
        if (startX === null) return;
        const dx = e.clientX - startX;
        startX = null;
        this.classList.remove('is-dragging');
        if (Math.abs(dx) > 40) {
          this.go(this.index + (dx < 0 ? 1 : -1));
          this.restart();
        }
      };
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', () => { startX = null; this.classList.remove('is-dragging'); });
      track.addEventListener('pointerleave', end);
      track.addEventListener('click', (e) => {
        if (!this.dragged) return;
        e.preventDefault();
        e.stopPropagation();
        this.dragged = false;
      }, true);
      track.addEventListener('dragstart', (e) => e.preventDefault());
    }
    go(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((s, n) => {
        const on = n === this.index;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === this.index));
      this.syncVideos();
    }
    // Só o vídeo do slide ativo toca (os outros ficam pausados no início); com
    // "reduzir movimento" nenhum toca e fica o poster.
    syncVideos() {
      this.slides.forEach((s, n) => {
        const video = s.querySelector('.prospirity-hero__video');
        if (!video) return;
        if (n === this.index && !this.reduceMotion) {
          video.play()?.catch(() => {});
        } else {
          video.pause();
          if (n !== this.index) video.currentTime = 0;
        }
      });
    }
    start() {
      if (this.timer || !this.inViewport) return;
      const ms = parseInt(this.dataset.interval, 10) || 5000;
      this.timer = setInterval(() => { if (!this.paused && Date.now() >= (this.userPauseUntil || 0)) this.go(this.index + 1); }, ms);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    restart() { this.stop(); this.start(); }
    disconnectedCallback() { this.stop(); this.observer?.disconnect(); }
  }
  if (!customElements.get('prospirity-hero')) customElements.define('prospirity-hero', ProspirityHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prospirity-lead-capture"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var UTM_KEY = 'prospirity-utm-source';
    function slug(value) {
      return String(value || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
    }
    function storedUtm() {
      try {
        var current = new URL(window.location.href).searchParams.get('utm_source');
        if (current) sessionStorage.setItem(UTM_KEY, current);
        return sessionStorage.getItem(UTM_KEY);
      } catch (e) { return null; }
    }
    function selectInterest(value) {
      var key = slug(value);
      if (!key) return;
      document.querySelectorAll('prospirity-lead-capture input[type="radio"][value="' + key + '"]').forEach(function (radio) { radio.checked = true; });
    }

    if (!customElements.get('prospirity-lead-capture')) {
      customElements.define('prospirity-lead-capture', class extends HTMLElement {
        connectedCallback() {
          if (this.__init) return;
          this.__init = true;
          var form = this.querySelector('form');
          var tags = form && form.querySelector('input[name="contact[tags]"]');
          if (!tags) return;
          var self = this;
          form.addEventListener('submit', function () {
            var list = (tags.dataset.baseTags || '').split(',').map(function (tag) { return tag.trim(); }).filter(Boolean);
            var interest = form.querySelector('.prospirity-lead__interest input:checked');
            if (interest) list.push(slug(self.dataset.interestPrefix + interest.value));
            var utm = self.dataset.tagUtm === 'true' ? slug(storedUtm()) : '';
            if (utm) list.push('utm-' + utm);
            tags.value = list.filter(function (tag, i) { return list.indexOf(tag) === i; }).join(', ');
          });
        }
      });
    }

    if (window.__prospirityLeadInit) return;
    window.__prospirityLeadInit = true;
    storedUtm();

    function init() {
      try { selectInterest(new URL(window.location.href).searchParams.get('interesse')); } catch (e) {}
      // Links "?interesse=gt#lista" na mesma página: marca o interesse; a rolagem fica com a âncora.
      document.addEventListener('click', function (event) {
        var link = event.target.closest && event.target.closest('a[href*="interesse="]');
        if (!link || link.origin !== window.location.origin || link.pathname !== window.location.pathname) return;
        selectInterest(new URL(link.href).searchParams.get('interesse'));
      }, true);

      var sticky = document.querySelector('.prospirity-lead-sticky');
      var forms = document.querySelectorAll('.prospirity-lead__form-wrap');
      if (!sticky || !forms.length || !('IntersectionObserver' in window)) return;
      sticky.hidden = false;
      var visible = new Set();
      function update() {
        sticky.classList.toggle('is-visible', visible.size === 0 && window.scrollY > window.innerHeight * 0.5);
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target); });
        update();
      });
      forms.forEach(function (wrap) { observer.observe(wrap); });
      window.addEventListener('scroll', update, { passive: true });
    }
    if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prospirity-logo-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProspirityLogoMarquee extends HTMLElement {
    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll('.prospirity-logo-carousel__group'));
      if (this.groups.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.originals = Array.from(this.groups[0].children).map((node) => node.cloneNode(true));
      if (!this.originals.length) return;

      this.fill = this.fill.bind(this);
      this.resizeObserver = new ResizeObserver(this.fill);
      this.resizeObserver.observe(this);
      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', this.fill, { once: true });
      });
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    // Repete o conjunto de logos dentro de cada metade da faixa até que uma
    // metade seja mais larga que a área visível. As duas metades continuam
    // idênticas, então a animação de -50% segue sem salto.
    fill() {
      const firstGroup = this.groups[0];
      const repeats = Number(firstGroup.dataset.repeats || 1);
      const setWidth = firstGroup.getBoundingClientRect().width / repeats;
      if (!setWidth) return;

      const needed = Math.max(1, Math.ceil(this.clientWidth / setWidth));
      if (needed === repeats) return;

      this.groups.forEach((group, groupIndex) => {
        const nodes = [];
        for (let copy = 0; copy < needed; copy++) {
          this.originals.forEach((node) => {
            const clone = node.cloneNode(true);
            if (groupIndex > 0 || copy > 0) {
              clone.setAttribute('aria-hidden', 'true');
              clone.setAttribute('tabindex', '-1');
            }
            nodes.push(clone);
          });
        }
        group.replaceChildren(...nodes);
        group.dataset.repeats = needed;
      });
      this.style.setProperty('--prospirity-logo-repeats', needed);
    }
  }

  if (!customElements.get('prospirity-logo-marquee')) customElements.define('prospirity-logo-marquee', ProspirityLogoMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prospirity-reels-strip"] && !Shopify.designMode) return;
  try {
    
  class ProspirityReelsStrip extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('[data-reels-track]');
      this.originalItems = Array.from(this.querySelectorAll('[data-reels-item]'));
      this.items = this.originalItems;
      this.dots = Array.from(this.querySelectorAll('[data-reels-go]'));
      if (!this.track || !this.items.length) return;
      this.activeIndex = Math.max(0, this.items.findIndex((item) => item.classList.contains('is-active')));
      this.originalItems.forEach((item, index) => { item.dataset.reelsIndex = index; });
      this.activeItem = this.originalItems[this.activeIndex];
      this.autoplayMode = this.dataset.autoplayMode || 'interval';
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.inViewport = false;
      this.pauseUntil = 0;
      /* Com "todos os vídeos visíveis", cada vídeo toca enquanto ao menos
         60% dele aparece na tela; com economia de dados, só o ativo. */
      this.playVisible = this.dataset.playVisible !== 'false' && !navigator.connection?.saveData;
      this.visibleItems = new Set();

      this.refreshActiveFromCenter = this.refreshActiveFromCenter.bind(this);
      this.onInteraction = () => {
        if (this.autoplayMode === 'video_end') return;
        this.pauseUntil = Date.now() + 8000;
        this.stopAutoplay();
        window.clearTimeout(this.autoplayRestartTimer);
        this.autoplayRestartTimer = window.setTimeout(() => this.startAutoplay(), 8000);
      };
      this.onPointerDown = (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.onInteraction();
        this.drag = { pointerId: event.pointerId, startX: event.clientX, startScrollLeft: this.track.scrollLeft, moved: false };
        this.track.classList.add('is-dragging');
      };
      this.onPointerMove = (event) => {
        if (!this.drag || event.pointerId !== this.drag.pointerId) return;
        const distance = event.clientX - this.drag.startX;
        // A captura só começa quando vira arrasto: capturar já no pointerdown
        // redireciona o clique para o trilho e o link do produto não abre.
        if (!this.drag.moved && Math.abs(distance) > 3) {
          this.drag.moved = true;
          this.track.setPointerCapture?.(event.pointerId);
        }
        if (!this.drag.moved) return;
        event.preventDefault();
        this.track.scrollLeft = this.drag.startScrollLeft - distance;
      };
      this.onPointerUp = (event) => {
        if (!this.drag || event.pointerId !== this.drag.pointerId) return;
        if (this.drag.moved) {
          this.suppressClick = true;
          window.setTimeout(() => { this.suppressClick = false; }, 0);
        }
        if (this.track.hasPointerCapture?.(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        this.drag = null;
        this.track.classList.remove('is-dragging');
        this.refreshActiveFromCenter();
      };
      this.onTrackClick = (event) => {
        if (this.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        const media = event.target.closest('.prospirity-reels-strip__media');
        const item = media?.closest('[data-reels-item]');
        if (!item || !this.track.contains(item)) return;
        this.onInteraction();
        const selectedVideo = item.querySelector('video');
        if (item !== this.activeItem && selectedVideo) selectedVideo.currentTime = 0;
        this.setActiveItem(item);
        this.positionOnItem(item);
      };
      this.onVideoEnded = (event) => {
        if (this.autoplayMode !== 'video_end' || !this.inViewport || document.hidden || this.dataset.autoplay !== 'true') return;
        const item = event.currentTarget.closest('[data-reels-item]');
        if (item !== this.activeItem) return;
        this.go(this.activeIndex + 1);
      };
      this.videos = this.items.map((item) => item.querySelector('video')).filter(Boolean);
      this.videos.forEach((video) => video.addEventListener('ended', this.onVideoEnded));
      this.track.addEventListener('pointerdown', this.onPointerDown);
      this.track.addEventListener('pointermove', this.onPointerMove, { passive: false });
      this.track.addEventListener('pointerup', this.onPointerUp);
      this.track.addEventListener('pointercancel', this.onPointerUp);
      this.track.addEventListener('click', this.onTrackClick, true);
      this.onPrevious = () => { this.onInteraction(); this.go(this.activeIndex - 1); };
      this.onNext = () => { this.onInteraction(); this.go(this.activeIndex + 1); };
      this.previousButton = this.querySelector('[data-reels-prev]');
      this.nextButton = this.querySelector('[data-reels-next]');
      this.previousButton?.addEventListener('click', this.onPrevious);
      this.nextButton?.addEventListener('click', this.onNext);
      this.onDotClick = (event) => { this.onInteraction(); this.go(Number(event.currentTarget.dataset.reelsGo)); };
      this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));

      this.resizeObserver = new ResizeObserver(() => this.refresh());
      this.resizeObserver.observe(this.track);
      this.visibilityObserver = new IntersectionObserver((entries) => {
        this.inViewport = entries[0]?.isIntersecting && !document.hidden;
        this.syncVideos();
        if (this.inViewport) this.startAutoplay(); else this.stopAutoplay();
      }, { threshold: 0.25 });
      this.visibilityObserver.observe(this);
      if (this.playVisible) {
        this.itemObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.visibleItems.add(entry.target); else this.visibleItems.delete(entry.target);
          });
          this.syncVideos();
        }, { threshold: 0.6 });
        this.items.forEach((item) => this.itemObserver.observe(item));
      }
      /* Ao fim de qualquer rolagem (dedo, trackpad, snap), o vídeo central
         vira o ativo e começa a tocar, sem depender de clique. */
      this.onScrollSettled = () => {
        if (this.drag || Date.now() < this.programmaticScrollUntil) return;
        this.refreshActiveFromCenter();
      };
      this.onTrackScroll = () => {
        window.clearTimeout(this.scrollSettleTimer);
        this.scrollSettleTimer = window.setTimeout(this.onScrollSettled, 140);
      };
      if ('onscrollend' in window) this.track.addEventListener('scrollend', this.onScrollSettled);
      else this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });
      this.onVisibilityChange = () => {
        this.inViewport = !document.hidden && this.getBoundingClientRect().bottom > 0 && this.getBoundingClientRect().top < window.innerHeight;
        this.syncVideos();
        if (this.inViewport) this.startAutoplay(); else this.stopAutoplay();
      };
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      window.requestAnimationFrame(() => this.refresh());
    }

    refreshActiveFromCenter() {
      const trackCenter = this.track.scrollLeft + this.track.clientWidth / 2;
      let nearestItem = this.items[0];
      let nearestDistance = Infinity;
      this.items.forEach((item) => {
        const distance = Math.abs(item.offsetLeft + item.offsetWidth / 2 - trackCenter);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestItem = item;
        }
      });
      this.setActiveItem(nearestItem);
    }

    setActiveItem(item) {
      if (!item) return;
      this.activeItem = item;
      this.activeIndex = Number(item.dataset.reelsIndex) || 0;
      this.items.forEach((candidate) => candidate.classList.toggle('is-active', candidate === item));
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.activeIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
      this.syncVideos();
      this.updateControls();
    }

    positionOnItem(item, behavior = 'smooth') {
      if (!item) return;
      /* Rolagem do próprio componente: nas pontas o ativo não fica no centro,
         e recalcular pelo centro trocaria o vídeo escolhido. */
      this.programmaticScrollUntil = Date.now() + 1200;
      this.track.scrollTo({
        left: item.offsetLeft - (this.track.clientWidth - item.offsetWidth) / 2,
        behavior
      });
    }

    go(index) {
      if (!this.canScroll) return;
      const isLooping = this.dataset.loop === 'true';
      if (!isLooping && (index < 0 || index >= this.originalItems.length)) return;
      const wrapped = index < 0 || index >= this.originalItems.length;
      const logicalIndex = (index + this.originalItems.length) % this.originalItems.length;
      const item = this.originalItems[logicalIndex];
      /* O próximo vídeo pode já estar tocando em loop (visível); ao virar o
         ativo ele recomeça, para o "ao terminar" contar o vídeo inteiro. */
      const nextVideo = item.querySelector('video');
      if (this.autoplayMode === 'video_end' && item !== this.activeItem && nextVideo) nextVideo.currentTime = 0;
      this.setActiveItem(item);
      /* Ao terminar, volta ao primeiro card real imediatamente. Não há cópias
         físicas nem normalização de scroll que possam saltar para o meio. */
      this.positionOnItem(item, wrapped ? 'auto' : 'smooth');
    }

    refresh() {
      const originalWidth = this.originalItems.length > 1
        ? this.originalItems[this.originalItems.length - 1].offsetLeft + this.originalItems[this.originalItems.length - 1].offsetWidth - this.originalItems[0].offsetLeft
        : 0;
      this.canScroll = originalWidth - this.track.clientWidth > 2;
      this.classList.toggle('is-scrollable', this.canScroll);
      this.updateControls();
      this.syncVideos();
      if (!this.canScroll) this.stopAutoplay(); else this.startAutoplay();
    }

    updateControls() {
      if (!this.canScroll) {
        if (this.previousButton) this.previousButton.disabled = true;
        if (this.nextButton) this.nextButton.disabled = true;
        return;
      }
      if (this.dataset.loop === 'true') {
        if (this.previousButton) this.previousButton.disabled = false;
        if (this.nextButton) this.nextButton.disabled = false;
        return;
      }
      if (this.previousButton) this.previousButton.disabled = this.activeIndex === 0;
      if (this.nextButton) this.nextButton.disabled = this.activeIndex === this.items.length - 1;
    }

    syncVideos() {
      this.items.forEach((item) => {
        const video = item.querySelector('video');
        if (!video) return;
        video.muted = true;
        video.playsInline = true;
        const isActive = item === this.activeItem;
        /* No modo "ao terminar o vídeo", só o ativo deixa de repetir: é o fim
           dele que avança a faixa. Os demais visíveis seguem em loop. */
        if (this.autoplayMode === 'video_end') video.loop = !isActive;
        const shouldPlay = this.inViewport && !document.hidden && (isActive || (this.playVisible && this.visibleItems.has(item)));
        if (shouldPlay) {
          if (video.paused) video.play().catch(() => {});
        } else video.pause();
      });
    }

    startAutoplay() {
      if (this.timer || !this.inViewport || !this.canScroll || this.reduceMotion || this.dataset.autoplay !== 'true') return;
      if (this.autoplayMode === 'video_end') return;
      const interval = Number(this.dataset.interval) || 5000;
      this.timer = window.setInterval(() => {
        if (Date.now() < this.pauseUntil) return;
        const next = this.activeIndex + 1;
        if (next >= this.originalItems.length && this.dataset.loop !== 'true') { this.stopAutoplay(); return; }
        this.go(next);
      }, interval);
    }

    stopAutoplay() { window.clearInterval(this.timer); this.timer = null; }

    disconnectedCallback() {
      this.track?.removeEventListener('pointerdown', this.onPointerDown);
      this.track?.removeEventListener('pointermove', this.onPointerMove);
      this.track?.removeEventListener('pointerup', this.onPointerUp);
      this.track?.removeEventListener('pointercancel', this.onPointerUp);
      this.track?.removeEventListener('click', this.onTrackClick, true);
      this.previousButton?.removeEventListener('click', this.onPrevious);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.dots?.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
      this.videos?.forEach((video) => video.removeEventListener('ended', this.onVideoEnded));
      this.stopAutoplay();
      window.clearTimeout(this.autoplayRestartTimer);
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.itemObserver?.disconnect();
      this.track?.removeEventListener('scrollend', this.onScrollSettled);
      this.track?.removeEventListener('scroll', this.onTrackScroll);
      window.clearTimeout(this.scrollSettleTimer);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
  }
  if (!customElements.get('prospirity-reels-strip')) customElements.define('prospirity-reels-strip', ProspirityReelsStrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prospirity-video-grid"] && !Shopify.designMode) return;
  try {
    
  class ProspirityVideoGrid extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.background = this.dataset.playback === 'background';
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.items = Array.from(this.querySelectorAll('[data-video-item]')).filter((item) => item.querySelector('iframe[data-src]'));

      this.items.forEach((item) => {
        if (this.background && this.reduceMotion) item.classList.add('is-click-fallback');
        item.querySelector('[data-video-play]')?.addEventListener('click', () => this.play(item));
      });

      if (!this.background || this.reduceMotion || !('IntersectionObserver' in window)) {
        if (this.background && !this.reduceMotion) this.items.forEach((item) => this.load(item, item.dataset.autoplaySrc));
        return;
      }

      // Carrega o player perto da viewport e pausa/retoma conforme a visibilidade.
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const item = entry.target;
          if (entry.isIntersecting) {
            if (!item.classList.contains('is-playing')) this.load(item, item.dataset.autoplaySrc);
            else this.command(item, 'play');
          } else if (item.classList.contains('is-playing')) {
            this.command(item, 'pause');
          }
        });
      }, { rootMargin: '200px 0px' });
      this.items.forEach((item) => this.observer.observe(item));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    load(item, src) {
      const frame = item.querySelector('iframe[data-src]');
      if (!frame || !src) return;
      frame.src = src;
      frame.hidden = false;
      item.classList.add('is-playing');
    }

    play(item) {
      item.classList.remove('is-click-fallback');
      this.load(item, item.dataset.clickSrc);
      item.querySelector('iframe[data-src]')?.focus();
    }

    command(item, action) {
      const frame = item.querySelector('iframe[data-src]');
      if (!frame?.contentWindow) return;
      const message = item.dataset.provider === 'vimeo'
        ? { method: action }
        : { event: 'command', func: action === 'pause' ? 'pauseVideo' : 'playVideo', args: [] };
      frame.contentWindow.postMessage(JSON.stringify(message), '*');
    }
  }

  if (!customElements.get('prospirity-video-grid')) customElements.define('prospirity-video-grid', ProspirityVideoGrid);

  } catch(e) { console.error(e); }
})();
})();
